//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @return Frontend-ViewModel (nur öffentliche Felder).
     */
    loadFrontendViewModel(cancelToken?: CancelToken): Promise<ConfigViewModel> {
        let url_ = this.baseUrl + "/config/frontend/viewmodel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadFrontendViewModel(_response);
        });
    }

    protected processLoadFrontendViewModel(response: AxiosResponse): Promise<ConfigViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ConfigViewModel.fromJS(resultData200);
            return Promise.resolve<ConfigViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigViewModel>(null as any);
    }

    /**
     * @return Admin-ViewModel (inkl. Prompt-Instructions).
     */
    loadAdminViewModel(cancelToken?: CancelToken): Promise<ConfigViewModel> {
        let url_ = this.baseUrl + "/config/admin/viewmodel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadAdminViewModel(_response);
        });
    }

    protected processLoadAdminViewModel(response: AxiosResponse): Promise<ConfigViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ConfigViewModel.fromJS(resultData200);
            return Promise.resolve<ConfigViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigViewModel>(null as any);
    }

    /**
     * @param body (optional) Aktualisiert Konfigurationswerte.
     * @return Aktualisierte Frontend-Konfiguration.
     */
    updateFrontendConfig(body: ConfigUpdateModel | null | undefined, cancelToken?: CancelToken): Promise<ConfigViewModel> {
        let url_ = this.baseUrl + "/UpdateFrontendConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateFrontendConfig(_response);
        });
    }

    protected processUpdateFrontendConfig(response: AxiosResponse): Promise<ConfigViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ConfigViewModel.fromJS(resultData200);
            return Promise.resolve<ConfigViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigViewModel>(null as any);
    }

    /**
     * @param body (optional) Anfrage an den AI Agent
     * @return Antwort des Assistenten
     */
    post(body: ChatRequestModel | null | undefined, cancelToken?: CancelToken): Promise<AssistantResponse> {
        let url_ = this.baseUrl + "/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<AssistantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AssistantResponse.fromJS(resultData200);
            return Promise.resolve<AssistantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantResponse>(null as any);
    }

    /**
     * @param body (optional) Komplette historie inklusive der ToolId, welche validiert und ausgeführt werden muss
     * @return Antwort des Assistenten
     */
    approveToolCall(body: ApproveToolCallRequestModel | null | undefined, cancelToken?: CancelToken): Promise<AssistantResponse> {
        let url_ = this.baseUrl + "/ApproveToolCall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveToolCall(_response);
        });
    }

    protected processApproveToolCall(response: AxiosResponse): Promise<AssistantResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AssistantResponse.fromJS(resultData200);
            return Promise.resolve<AssistantResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantResponse>(null as any);
    }
}

export class ConfigClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @return Liste aller konfigurierten Assistenten.
     */
    listAssistants(cancelToken?: CancelToken): Promise<AssistantDefinition[]> {
        let url_ = this.baseUrl + "/assistants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAssistants(_response);
        });
    }

    protected processListAssistants(response: AxiosResponse): Promise<AssistantDefinition[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssistantDefinition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AssistantDefinition[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantDefinition[]>(null as any);
    }

    /**
     * @param body (optional) Neuen Assistenten anlegen (id wird serverseitig generiert).
     * @return Angelegter Assistent.
     */
    createAssistant(body: AssistantDefinition | null | undefined, cancelToken?: CancelToken): Promise<AssistantDefinition> {
        let url_ = this.baseUrl + "/assistants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateAssistant(_response);
        });
    }

    protected processCreateAssistant(response: AxiosResponse): Promise<AssistantDefinition> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AssistantDefinition.fromJS(resultData200);
            return Promise.resolve<AssistantDefinition>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantDefinition>(null as any);
    }

    /**
     * @param assistant assistant internalName
     * @return Prompt-Configs für einen Assistenten (Dropdown).
     */
    listAssistantPrompts(assistant: string, cancelToken?: CancelToken): Promise<DocumentAnswerPromptConfiguration[]> {
        let url_ = this.baseUrl + "/assistants/{assistant}/prompts";
        if (assistant === undefined || assistant === null)
            throw new Error("The parameter 'assistant' must be defined.");
        url_ = url_.replace("{assistant}", encodeURIComponent("" + assistant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAssistantPrompts(_response);
        });
    }

    protected processListAssistantPrompts(response: AxiosResponse): Promise<DocumentAnswerPromptConfiguration[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentAnswerPromptConfiguration.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DocumentAnswerPromptConfiguration[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentAnswerPromptConfiguration[]>(null as any);
    }

    /**
     * @param assistant assistant internalName
     * @return Lösch-Status.
     */
    deleteAssistant(assistant: string, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/assistants/{assistant}";
        if (assistant === undefined || assistant === null)
            throw new Error("The parameter 'assistant' must be defined.");
        url_ = url_.replace("{assistant}", encodeURIComponent("" + assistant));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAssistant(_response);
        });
    }

    protected processDeleteAssistant(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param id Assistant id
     * @param body (optional) Aktualisierter Assistent (id/internalName readonly).
     * @return Aktualisierter Assistent.
     */
    updateAssistant(id: string, body: AssistantDefinition | null | undefined, cancelToken?: CancelToken): Promise<AssistantDefinition> {
        let url_ = this.baseUrl + "/assistants/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAssistant(_response);
        });
    }

    protected processUpdateAssistant(response: AxiosResponse): Promise<AssistantDefinition> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = AssistantDefinition.fromJS(resultData200);
            return Promise.resolve<AssistantDefinition>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssistantDefinition>(null as any);
    }

    /**
     * @param body (optional) Aktualisiert den OpenAI API Key (nur openAiKey).
     * @return Bestätigung der Aktualisierung.
     */
    updateApiKey(body: ConfigUpdateModel | null | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/config/apikey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateApiKey(_response);
        });
    }

    protected processUpdateApiKey(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class OpenAIClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @param start (optional) Optional: Startzeitpunkt (ISO 8601, UTC empfohlen). Standard ist Monatsanfang UTC.
     * @param end (optional) Optional: Endzeitpunkt (ISO 8601, UTC empfohlen). Standard ist jetzt (UTC).
     * @return Kosten/Budget-Zusammenfassung für den Zeitraum.
     */
    getBudget(start: string | null | undefined, end: string | null | undefined, cancelToken?: CancelToken): Promise<OpenAiBudgetResponse> {
        let url_ = this.baseUrl + "/openai/budget?";
        if (start !== undefined && start !== null)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end !== undefined && end !== null)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudget(_response);
        });
    }

    protected processGetBudget(response: AxiosResponse): Promise<OpenAiBudgetResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = OpenAiBudgetResponse.fromJS(resultData200);
            return Promise.resolve<OpenAiBudgetResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OpenAiBudgetResponse>(null as any);
    }
}

export class FilesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @param fileName Dateiname des hochzuladenden Dokuments
     * @param subfolder (optional) Unterordner im Tenant-Container (optional).
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @return Die generierte SAS-Upload-URL
     */
    generateSasUrl(fileName: string, subfolder: string | null | undefined, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/sas/{fileName}?";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        if (subfolder !== undefined && subfolder !== null)
            url_ += "subfolder=" + encodeURIComponent("" + subfolder) + "&";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateSasUrl(_response);
        });
    }

    protected processGenerateSasUrl(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param fileUrl Datei-URL (z. B. openai:fileId)
     */
    download(fileUrl: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/files/download?";
        if (fileUrl === undefined || fileUrl === null)
            throw new Error("The parameter 'fileUrl' must be defined and cannot be null.");
        else
            url_ += "fileUrl=" + encodeURIComponent("" + fileUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownload(_response);
        });
    }

    protected processDownload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param fileUrl Vollständige Blob-URL (ggf. mit SAS), URL-kodiert
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Vector Stores.
     * @return Ergebnis des Einbettens (Doc-Infos/Chunks)
     */
    embedByUrl(fileUrl: string, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/embed?";
        if (fileUrl === undefined || fileUrl === null)
            throw new Error("The parameter 'fileUrl' must be defined and cannot be null.");
        else
            url_ += "fileUrl=" + encodeURIComponent("" + fileUrl) + "&";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmbedByUrl(_response);
        });
    }

    protected processEmbedByUrl(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param subfolder (optional) Unterordner im Tenant-Container, optional. Catch-All erlaubt Schrägstriche.
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Vector Stores.
     * @return Ergebnis pro Datei nach Upload + Embedding.
     */
    uploadAndEmbed(subfolder: string | null | undefined, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<FileEmbedResponseItem[]> {
        let url_ = this.baseUrl + "/files/upload/{*subfolder}?";
        if (subfolder !== null && subfolder !== undefined)
            url_ = url_.replace("{subfolder}", encodeURIComponent("" + subfolder));
        else
            url_ = url_.replace("/{subfolder}", "");
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadAndEmbed(_response);
        });
    }

    protected processUploadAndEmbed(response: AxiosResponse): Promise<FileEmbedResponseItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileEmbedResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FileEmbedResponseItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEmbedResponseItem[]>(null as any);
    }

    /**
     * @param folder (optional) Optionaler Ordner im Tenant-Container, aus dem gelistet werden soll.
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @return Datei- und Ordnerliste im aktuellen Tenant-Container.
     */
    list(folder: string | null | undefined, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<FileListItem[]> {
        let url_ = this.baseUrl + "/files?";
        if (folder !== undefined && folder !== null)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<FileListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FileListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileListItem[]>(null as any);
    }

    /**
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @param body (optional) Legt einen neuen Ordner an.
     * @return Bestätigungstext.
     */
    createFolder(assistant: string | null | undefined, body: FolderCreateRequest | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/folders?";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateFolder(_response);
        });
    }

    protected processCreateFolder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @param body (optional) Alten und neuen Ordnernamen angeben.
     * @return Bestätigungstext.
     */
    renameFolder(assistant: string | null | undefined, body: FolderRenameRequest | null | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/folders/rename?";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameFolder(_response);
        });
    }

    protected processRenameFolder(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param folderPath Ordnerpfad im Tenant-Container, URL-kodiert.
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @return Welche Dateien und Embeddings entfernt wurden.
     */
    deleteFolder(folderPath: string, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<FolderDeleteResult> {
        let url_ = this.baseUrl + "/folders/{*folderPath}?";
        if (folderPath === undefined || folderPath === null)
            throw new Error("The parameter 'folderPath' must be defined.");
        url_ = url_.replace("{folderPath}", encodeURIComponent("" + folderPath));
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteFolder(_response);
        });
    }

    protected processDeleteFolder(response: AxiosResponse): Promise<FolderDeleteResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = FolderDeleteResult.fromJS(resultData200);
            return Promise.resolve<FolderDeleteResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FolderDeleteResult>(null as any);
    }

    /**
     * @param subfolder (optional) Unterordner im Tenant-Container, optional. Catch-All erlaubt Schrägstriche.
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @return Ergebnis pro Datei nach Upload (ohne Embedding).
     */
    upload(subfolder: string | null | undefined, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<FileUploadResponseItem[]> {
        let url_ = this.baseUrl + "/files/upload-only/{*subfolder}?";
        if (subfolder !== null && subfolder !== undefined)
            url_ = url_.replace("{subfolder}", encodeURIComponent("" + subfolder));
        else
            url_ = url_.replace("/{subfolder}", "");
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<FileUploadResponseItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileUploadResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FileUploadResponseItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponseItem[]>(null as any);
    }

    /**
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Vector Stores.
     * @param body (optional) Liste der Blob-URLs, die eingebettet werden sollen
     * @return Ergebnis pro Datei inkl. Anzahl Chunks
     */
    embedBatch(assistant: string | null | undefined, body: FileEmbedRequest | null | undefined, cancelToken?: CancelToken): Promise<FileEmbedResponseItem[]> {
        let url_ = this.baseUrl + "/embed/batch?";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmbedBatch(_response);
        });
    }

    protected processEmbedBatch(response: AxiosResponse): Promise<FileEmbedResponseItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileEmbedResponseItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FileEmbedResponseItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileEmbedResponseItem[]>(null as any);
    }

    /**
     * @param fileUrl Vollständige Blob-URL (ggf. mit SAS), URL-kodiert
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Vector Stores.
     * @return Gibt zurück, welche DocIds gelöscht wurden und ob der Blob entfernt wurde.
     */
    delete(fileUrl: string, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<FileDeleteResult> {
        let url_ = this.baseUrl + "/files/delete?";
        if (fileUrl === undefined || fileUrl === null)
            throw new Error("The parameter 'fileUrl' must be defined and cannot be null.");
        else
            url_ += "fileUrl=" + encodeURIComponent("" + fileUrl) + "&";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileDeleteResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = FileDeleteResult.fromJS(resultData200);
            return Promise.resolve<FileDeleteResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileDeleteResult>(null as any);
    }

    /**
     * @param subfolder Unterordner im Tenant-Container. Catch-All erlaubt Schrägstriche (z. B. docs/2025/Q4)
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @return Liste der Blob-URLs, die (noch) eingebettet werden sollen
     */
    listPendingEmbeds(subfolder: string, assistant: string | null | undefined, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/embed/pending/{*subfolder}?";
        if (subfolder === undefined || subfolder === null)
            throw new Error("The parameter 'subfolder' must be defined.");
        url_ = url_.replace("{subfolder}", encodeURIComponent("" + subfolder));
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListPendingEmbeds(_response);
        });
    }

    protected processListPendingEmbeds(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class PdfClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @param body (optional) Markdown-Inhalt für den PDF-Export
     * @return PDF-Bytes
     */
    render(body: PdfRenderRequest | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/pdf/render";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/pdf"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRender(_response);
        });
    }

    protected processRender(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param body (optional) PDF erstellen und per Mail versenden
     */
    share(body: PdfShareRequest | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/pdf/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShare(_response);
        });
    }

    protected processShare(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ChatClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @param body (optional) Chatverlauf als JSON per Mail versenden
     */
    share(body: ChatShareRequest | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/chat/share";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processShare(_response);
        });
    }

    protected processShare(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LiveShareClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @return Neuer LiveShare-Token
     */
    start(cancelToken?: CancelToken): Promise<LiveShareStartResponse> {
        let url_ = this.baseUrl + "/liveshare/start";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<LiveShareStartResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = LiveShareStartResponse.fromJS(resultData200);
            return Promise.resolve<LiveShareStartResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LiveShareStartResponse>(null as any);
    }

    /**
     * @param body (optional) LiveShare Nachricht senden
     */
    send(body: LiveShareSendRequest | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/liveshare/send";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSend(_response);
        });
    }

    protected processSend(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @param query Displayname oder E-Mail
     */
    resolve(query: string, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/users/resolve?";
        if (query === undefined || query === null)
            throw new Error("The parameter 'query' must be defined and cannot be null.");
        else
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResolve(_response);
        });
    }

    protected processResolve(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const resultData200 = response.data;
            if (Array.isArray(resultData200)) {
                return Promise.resolve<string[]>(resultData200.map((item: any) => String(item)));
            }
            if (typeof resultData200 === "string") {
                try {
                    const parsed = JSON.parse(resultData200);
                    if (Array.isArray(parsed)) {
                        return Promise.resolve<string[]>(parsed.map((item: any) => String(item)));
                    }
                } catch {
                    // ignore parse errors, fall through
                }
            }
            return Promise.resolve<string[]>([]);
        }
        if (status === 204) {
            return Promise.resolve<string[]>([]);
        }
        if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>([]);
    }
}

export class ProfileClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @param assistant (optional) Optionaler Assistant internalName für die Auswahl des Pfad-Prefixes.
     * @param body (optional) Profil-Datei (Base64). Datei wird unter profiles/ mit dem angegebenen Dateinamen gespeichert.
     * @return Ergebnis des Profil-Uploads.
     */
    upload(assistant: string | null | undefined, body: UploadedFileModel | null | undefined, cancelToken?: CancelToken): Promise<FileUploadResponseItem> {
        let url_ = this.baseUrl + "/profile?";
        if (assistant !== undefined && assistant !== null)
            url_ += "assistant=" + encodeURIComponent("" + assistant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<FileUploadResponseItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = FileUploadResponseItem.fromJS(resultData200);
            return Promise.resolve<FileUploadResponseItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileUploadResponseItem>(null as any);
    }

    /**
     * @return KI-basierter Profilvorschlag im Stil des bestehenden Profils.
     */
    suggest(cancelToken?: CancelToken): Promise<ProfileSuggestionResponse> {
        let url_ = this.baseUrl + "/profile/suggest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuggest(_response);
        });
    }

    protected processSuggest(response: AxiosResponse): Promise<ProfileSuggestionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ProfileSuggestionResponse.fromJS(resultData200);
            return Promise.resolve<ProfileSuggestionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileSuggestionResponse>(null as any);
    }

    /**
     * @param body (optional) Profil-Datei (Base64) als Input für den KI-Vorschlag.
     * @return KI-basierter Profilvorschlag im Stil des hochgeladenen Profils.
     */
    suggestFromUpload(body: UploadedFileModel | null | undefined, cancelToken?: CancelToken): Promise<ProfileSuggestionResponse> {
        let url_ = this.baseUrl + "/profile/suggest/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSuggestFromUpload(_response);
        });
    }

    protected processSuggestFromUpload(response: AxiosResponse): Promise<ProfileSuggestionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = ProfileSuggestionResponse.fromJS(resultData200);
            return Promise.resolve<ProfileSuggestionResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProfileSuggestionResponse>(null as any);
    }

    /**
     * @return Gibt das Unternehmensprofil als JSON zurück (via LLM).
     */
    getJson(cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/profile/json";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJson(_response);
        });
    }

    protected processGetJson(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class SignalRClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7285/api";

    }

    /**
     * @param chatId Chat-ID, wird als UserId für den Hub genutzt
     * @return SignalR-ConnectionInfo für den Hub 'chat'
     */
    negotiate(chatId: string, cancelToken?: CancelToken): Promise<SignalRConnectionInfo> {
        let url_ = this.baseUrl + "/signalr/negotiate?";
        if (chatId === undefined || chatId === null)
            throw new Error("The parameter 'chatId' must be defined and cannot be null.");
        else
            url_ += "chatId=" + encodeURIComponent("" + chatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNegotiate(_response);
        });
    }

    protected processNegotiate(response: AxiosResponse): Promise<SignalRConnectionInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = SignalRConnectionInfo.fromJS(resultData200);
            return Promise.resolve<SignalRConnectionInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SignalRConnectionInfo>(null as any);
    }

    /**
     * @param chatId Chat-ID, wird als UserId für den Hub genutzt
     * @param lastSeq Letzte empfangene Sequenznummer
     * @return Replay-Pakete seit lastSeq
     */
    replay(chatId: string, lastSeq: number, cancelToken?: CancelToken): Promise<any> {
        let url_ = this.baseUrl + "/signalr/replay?";
        if (chatId === undefined || chatId === null)
            throw new Error("The parameter 'chatId' must be defined and cannot be null.");
        else
            url_ += "chatId=" + encodeURIComponent("" + chatId) + "&";
        if (lastSeq === undefined || lastSeq === null)
            throw new Error("The parameter 'lastSeq' must be defined and cannot be null.");
        else
            url_ += "lastSeq=" + encodeURIComponent("" + lastSeq) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplay(_response);
        });
    }

    protected processReplay(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class ApproveToolCallRequestModel implements IApproveToolCallRequestModel {
    history?: ChatMessageModel[] | undefined;
    toolCallIdToExecute?: string | undefined;

    constructor(data?: IApproveToolCallRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ChatMessageModel.fromJS(item));
            }
            this.toolCallIdToExecute = _data["toolCallIdToExecute"];
        }
    }

    static fromJS(data: any): ApproveToolCallRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApproveToolCallRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : <any>undefined);
        }
        data["toolCallIdToExecute"] = this.toolCallIdToExecute;
        return data;
    }
}

export interface IApproveToolCallRequestModel {
    history?: ChatMessageModel[] | undefined;
    toolCallIdToExecute?: string | undefined;
}

export class AssistantDefinition implements IAssistantDefinition {
    id?: string | undefined;
    name?: string | undefined;
    internalName?: string | undefined;
    topics?: string | undefined;
    vectorStoreId?: string | undefined;
    isDefault?: boolean | undefined;
    assistentPrompt?: string | undefined;
    assistentLlmModel?: string | undefined;
    promptDefinitions?: DocumentAnswerPromptDefinition[] | undefined;

    constructor(data?: IAssistantDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.internalName = _data["internalName"];
            this.topics = _data["topics"];
            this.vectorStoreId = _data["vectorStoreId"];
            this.isDefault = _data["isDefault"];
            this.assistentPrompt = _data["assistentPrompt"];
            this.assistentLlmModel = _data["assistentLlmModel"];
            if (Array.isArray(_data["promptDefinitions"])) {
                this.promptDefinitions = [] as any;
                for (let item of _data["promptDefinitions"])
                    this.promptDefinitions!.push(DocumentAnswerPromptDefinition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssistantDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new AssistantDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["internalName"] = this.internalName;
        data["topics"] = this.topics;
        data["vectorStoreId"] = this.vectorStoreId;
        data["isDefault"] = this.isDefault;
        data["assistentPrompt"] = this.assistentPrompt;
        data["assistentLlmModel"] = this.assistentLlmModel;
        if (Array.isArray(this.promptDefinitions)) {
            data["promptDefinitions"] = [];
            for (let item of this.promptDefinitions)
                data["promptDefinitions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAssistantDefinition {
    id?: string | undefined;
    name?: string | undefined;
    internalName?: string | undefined;
    topics?: string | undefined;
    vectorStoreId?: string | undefined;
    isDefault?: boolean | undefined;
    assistentPrompt?: string | undefined;
    assistentLlmModel?: string | undefined;
    promptDefinitions?: DocumentAnswerPromptDefinition[] | undefined;
}

export class AssistantResponse implements IAssistantResponse {
    chatId?: string | undefined;
    currentTurnMessages?: ChatMessageModel[] | undefined;
    clarification?: ClarificationResponse | undefined;
    history?: ChatMessageModel[] | undefined;

    constructor(data?: IAssistantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatId = _data["chatId"];
            if (Array.isArray(_data["currentTurnMessages"])) {
                this.currentTurnMessages = [] as any;
                for (let item of _data["currentTurnMessages"])
                    this.currentTurnMessages!.push(ChatMessageModel.fromJS(item));
            }
            this.clarification = _data["clarification"] ? ClarificationResponse.fromJS(_data["clarification"]) : <any>undefined;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ChatMessageModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssistantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AssistantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatId"] = this.chatId;
        if (Array.isArray(this.currentTurnMessages)) {
            data["currentTurnMessages"] = [];
            for (let item of this.currentTurnMessages)
                data["currentTurnMessages"].push(item ? item.toJSON() : <any>undefined);
        }
        data["clarification"] = this.clarification ? this.clarification.toJSON() : <any>undefined;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAssistantResponse {
    chatId?: string | undefined;
    currentTurnMessages?: ChatMessageModel[] | undefined;
    clarification?: ClarificationResponse | undefined;
    history?: ChatMessageModel[] | undefined;
}

export class ChatMessageModel implements IChatMessageModel {
    role?: string | undefined;
    content?: string | undefined;
    clarification?: ClarificationResponse | undefined;
    downloadRequest?: DownloadRequestModel | undefined;
    toolCalls?: ToolCallViewModel[] | undefined;
    toolResult?: ToolResultViewModel | undefined;

    constructor(data?: IChatMessageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"];
            this.content = _data["content"];
            this.clarification = _data["clarification"] ? ClarificationResponse.fromJS(_data["clarification"]) : <any>undefined;
            this.downloadRequest = _data["downloadRequest"] ? DownloadRequestModel.fromJS(_data["downloadRequest"]) : <any>undefined;
            if (Array.isArray(_data["toolCalls"])) {
                this.toolCalls = [] as any;
                for (let item of _data["toolCalls"])
                    this.toolCalls!.push(ToolCallViewModel.fromJS(item));
            }
            this.toolResult = _data["toolResult"] ? ToolResultViewModel.fromJS(_data["toolResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ChatMessageModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role;
        data["content"] = this.content;
        data["clarification"] = this.clarification ? this.clarification.toJSON() : <any>undefined;
        data["downloadRequest"] = this.downloadRequest ? this.downloadRequest.toJSON() : <any>undefined;
        if (Array.isArray(this.toolCalls)) {
            data["toolCalls"] = [];
            for (let item of this.toolCalls)
                data["toolCalls"].push(item ? item.toJSON() : <any>undefined);
        }
        data["toolResult"] = this.toolResult ? this.toolResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IChatMessageModel {
    role?: string | undefined;
    content?: string | undefined;
    clarification?: ClarificationResponse | undefined;
    downloadRequest?: DownloadRequestModel | undefined;
    toolCalls?: ToolCallViewModel[] | undefined;
    toolResult?: ToolResultViewModel | undefined;
}

export class ChatRequestModel implements IChatRequestModel {
    chatId?: string | undefined;
    history?: ChatMessageModel[] | undefined;
    userMessage?: string | undefined;
    clarification?: ClarificationResponse | undefined;
    saasFileUrl?: string | undefined;
    files?: UploadedFileModel[] | undefined;
    assistantInternalName?: string | undefined;
    promptConfigKey?: string | undefined;
    includeProfile?: boolean | undefined;

    constructor(data?: IChatRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chatId = _data["chatId"];
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ChatMessageModel.fromJS(item));
            }
            this.userMessage = _data["userMessage"];
            this.clarification = _data["clarification"] ? ClarificationResponse.fromJS(_data["clarification"]) : <any>undefined;
            this.saasFileUrl = _data["saasFileUrl"];
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(UploadedFileModel.fromJS(item));
            }
            this.assistantInternalName = _data["assistantInternalName"];
            this.promptConfigKey = _data["promptConfigKey"];
            this.includeProfile = _data["includeProfile"];
        }
    }

    static fromJS(data: any): ChatRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChatRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chatId"] = this.chatId;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : <any>undefined);
        }
        data["userMessage"] = this.userMessage;
        data["clarification"] = this.clarification ? this.clarification.toJSON() : <any>undefined;
        data["saasFileUrl"] = this.saasFileUrl;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : <any>undefined);
        }
        data["assistantInternalName"] = this.assistantInternalName;
        data["promptConfigKey"] = this.promptConfigKey;
        data["includeProfile"] = this.includeProfile;
        return data;
    }
}

export interface IChatRequestModel {
    chatId?: string | undefined;
    history?: ChatMessageModel[] | undefined;
    userMessage?: string | undefined;
    clarification?: ClarificationResponse | undefined;
    saasFileUrl?: string | undefined;
    files?: UploadedFileModel[] | undefined;
    assistantInternalName?: string | undefined;
    promptConfigKey?: string | undefined;
    includeProfile?: boolean | undefined;
}

export class ChatShareRequest implements IChatShareRequest {
    recipients?: string[] | undefined;
    subject?: string | undefined;
    fileName?: string | undefined;
    payloadJson?: string | undefined;

    constructor(data?: IChatShareRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.subject = _data["subject"];
            this.fileName = _data["fileName"];
            this.payloadJson = _data["payloadJson"];
        }
    }

    static fromJS(data: any): ChatShareRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChatShareRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["subject"] = this.subject;
        data["fileName"] = this.fileName;
        data["payloadJson"] = this.payloadJson;
        return data;
    }
}

export interface IChatShareRequest {
    recipients?: string[] | undefined;
    subject?: string | undefined;
    fileName?: string | undefined;
    payloadJson?: string | undefined;
}

export class ClarificationItem implements IClarificationItem {
    id?: string | undefined;
    question?: string | undefined;
    answer?: string | undefined;

    constructor(data?: IClarificationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.question = _data["question"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): ClarificationItem {
        data = typeof data === 'object' ? data : {};
        let result = new ClarificationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["question"] = this.question;
        data["answer"] = this.answer;
        return data;
    }
}

export interface IClarificationItem {
    id?: string | undefined;
    question?: string | undefined;
    answer?: string | undefined;
}

export class ClarificationResponse implements IClarificationResponse {
    messageId?: string | undefined;
    question?: string | undefined;
    questions?: ClarificationItem[] | undefined;

    constructor(data?: IClarificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"];
            this.question = _data["question"];
            if (Array.isArray(_data["questions"])) {
                this.questions = [] as any;
                for (let item of _data["questions"])
                    this.questions!.push(ClarificationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClarificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ClarificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId;
        data["question"] = this.question;
        if (Array.isArray(this.questions)) {
            data["questions"] = [];
            for (let item of this.questions)
                data["questions"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IClarificationResponse {
    messageId?: string | undefined;
    question?: string | undefined;
    questions?: ClarificationItem[] | undefined;
}

export class ConfigUpdateModel implements IConfigUpdateModel {
    openAiKey?: string | undefined;
    documentSkillPrompts?: DocumentAnswerPromptConfiguration[] | undefined;
    documentAssistants?: AssistantDefinition[] | undefined;
    profileFile?: string | undefined;
    profileContent?: string | undefined;
    systemPrompt?: string | undefined;
    profileSystemPrompt?: string | undefined;

    constructor(data?: IConfigUpdateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openAiKey = _data["openAiKey"];
            if (Array.isArray(_data["documentSkillPrompts"])) {
                this.documentSkillPrompts = [] as any;
                for (let item of _data["documentSkillPrompts"])
                    this.documentSkillPrompts!.push(DocumentAnswerPromptConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["documentAssistants"])) {
                this.documentAssistants = [] as any;
                for (let item of _data["documentAssistants"])
                    this.documentAssistants!.push(AssistantDefinition.fromJS(item));
            }
            this.profileFile = _data["profileFile"];
            this.profileContent = _data["profileContent"];
            this.systemPrompt = _data["systemPrompt"];
            this.profileSystemPrompt = _data["profileSystemPrompt"];
        }
    }

    static fromJS(data: any): ConfigUpdateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigUpdateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openAiKey"] = this.openAiKey;
        if (Array.isArray(this.documentSkillPrompts)) {
            data["documentSkillPrompts"] = [];
            for (let item of this.documentSkillPrompts)
                data["documentSkillPrompts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentAssistants)) {
            data["documentAssistants"] = [];
            for (let item of this.documentAssistants)
                data["documentAssistants"].push(item ? item.toJSON() : <any>undefined);
        }
        data["profileFile"] = this.profileFile;
        data["profileContent"] = this.profileContent;
        data["systemPrompt"] = this.systemPrompt;
        data["profileSystemPrompt"] = this.profileSystemPrompt;
        return data;
    }
}

export interface IConfigUpdateModel {
    openAiKey?: string | undefined;
    documentSkillPrompts?: DocumentAnswerPromptConfiguration[] | undefined;
    documentAssistants?: AssistantDefinition[] | undefined;
    profileFile?: string | undefined;
    profileContent?: string | undefined;
    systemPrompt?: string | undefined;
    profileSystemPrompt?: string | undefined;
}

export class ConfigViewModel implements IConfigViewModel {
    openAiTokenExists?: boolean | undefined;
    documentSkillPrompts?: DocumentAnswerPromptConfiguration[] | undefined;
    documentAnswerPromptConfigurations?: DocumentAnswerPromptConfiguration[] | undefined;
    documentAssistants?: AssistantDefinition[] | undefined;
    profileFile?: string | undefined;
    systemPrompt?: string | undefined;
    profileSystemPrompt?: string | undefined;

    constructor(data?: IConfigViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.openAiTokenExists = _data["openAiTokenExists"];
            if (Array.isArray(_data["documentSkillPrompts"])) {
                this.documentSkillPrompts = [] as any;
                for (let item of _data["documentSkillPrompts"])
                    this.documentSkillPrompts!.push(DocumentAnswerPromptConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["documentAnswerPromptConfigurations"])) {
                this.documentAnswerPromptConfigurations = [] as any;
                for (let item of _data["documentAnswerPromptConfigurations"])
                    this.documentAnswerPromptConfigurations!.push(DocumentAnswerPromptConfiguration.fromJS(item));
            }
            if (Array.isArray(_data["documentAssistants"])) {
                this.documentAssistants = [] as any;
                for (let item of _data["documentAssistants"])
                    this.documentAssistants!.push(AssistantDefinition.fromJS(item));
            }
            this.profileFile = _data["profileFile"];
            this.systemPrompt = _data["systemPrompt"];
            this.profileSystemPrompt = _data["profileSystemPrompt"];
        }
    }

    static fromJS(data: any): ConfigViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["openAiTokenExists"] = this.openAiTokenExists;
        if (Array.isArray(this.documentSkillPrompts)) {
            data["documentSkillPrompts"] = [];
            for (let item of this.documentSkillPrompts)
                data["documentSkillPrompts"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentAnswerPromptConfigurations)) {
            data["documentAnswerPromptConfigurations"] = [];
            for (let item of this.documentAnswerPromptConfigurations)
                data["documentAnswerPromptConfigurations"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.documentAssistants)) {
            data["documentAssistants"] = [];
            for (let item of this.documentAssistants)
                data["documentAssistants"].push(item ? item.toJSON() : <any>undefined);
        }
        data["profileFile"] = this.profileFile;
        data["systemPrompt"] = this.systemPrompt;
        data["profileSystemPrompt"] = this.profileSystemPrompt;
        return data;
    }
}

export interface IConfigViewModel {
    openAiTokenExists?: boolean | undefined;
    documentSkillPrompts?: DocumentAnswerPromptConfiguration[] | undefined;
    documentAnswerPromptConfigurations?: DocumentAnswerPromptConfiguration[] | undefined;
    documentAssistants?: AssistantDefinition[] | undefined;
    profileFile?: string | undefined;
    systemPrompt?: string | undefined;
    profileSystemPrompt?: string | undefined;
}

export class DocumentAnswerPromptConfiguration implements IDocumentAnswerPromptConfiguration {
    key?: string | undefined;
    displayName?: string | undefined;
    promptInstruction?: string | undefined;
    llmModel?: string | undefined;
    isDefault?: boolean | undefined;

    constructor(data?: IDocumentAnswerPromptConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.promptInstruction = _data["promptInstruction"];
            this.llmModel = _data["llmModel"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): DocumentAnswerPromptConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAnswerPromptConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["promptInstruction"] = this.promptInstruction;
        data["llmModel"] = this.llmModel;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IDocumentAnswerPromptConfiguration {
    key?: string | undefined;
    displayName?: string | undefined;
    promptInstruction?: string | undefined;
    llmModel?: string | undefined;
    isDefault?: boolean | undefined;
}

export class DocumentAnswerPromptDefinition implements IDocumentAnswerPromptDefinition {
    key?: string | undefined;
    displayName?: string | undefined;
    promptInstruction?: string | undefined;
    llmModel?: string | undefined;
    isDefault?: boolean | undefined;

    constructor(data?: IDocumentAnswerPromptDefinition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.displayName = _data["displayName"];
            this.promptInstruction = _data["promptInstruction"];
            this.llmModel = _data["llmModel"];
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): DocumentAnswerPromptDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAnswerPromptDefinition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["displayName"] = this.displayName;
        data["promptInstruction"] = this.promptInstruction;
        data["llmModel"] = this.llmModel;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IDocumentAnswerPromptDefinition {
    key?: string | undefined;
    displayName?: string | undefined;
    promptInstruction?: string | undefined;
    llmModel?: string | undefined;
    isDefault?: boolean | undefined;
}

export class DownloadRequestModel implements IDownloadRequestModel {
    id?: string | undefined;
    fileName?: string | undefined;
    markdownContent?: string | undefined;
    createdAtUtc?: number | undefined;

    constructor(data?: IDownloadRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.markdownContent = _data["markdownContent"];
            this.createdAtUtc = _data["createdAtUtc"];
        }
    }

    static fromJS(data: any): DownloadRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["markdownContent"] = this.markdownContent;
        data["createdAtUtc"] = this.createdAtUtc;
        return data;
    }
}

export interface IDownloadRequestModel {
    id?: string | undefined;
    fileName?: string | undefined;
    markdownContent?: string | undefined;
    createdAtUtc?: number | undefined;
}

export class FileDeleteResult implements IFileDeleteResult {
    fileUrl?: string | undefined;
    deletedDocIds?: string[] | undefined;
    blobDeleted?: boolean | undefined;

    constructor(data?: IFileDeleteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
            if (Array.isArray(_data["deletedDocIds"])) {
                this.deletedDocIds = [] as any;
                for (let item of _data["deletedDocIds"])
                    this.deletedDocIds!.push(item);
            }
            this.blobDeleted = _data["blobDeleted"];
        }
    }

    static fromJS(data: any): FileDeleteResult {
        data = typeof data === 'object' ? data : {};
        let result = new FileDeleteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        if (Array.isArray(this.deletedDocIds)) {
            data["deletedDocIds"] = [];
            for (let item of this.deletedDocIds)
                data["deletedDocIds"].push(item);
        }
        data["blobDeleted"] = this.blobDeleted;
        return data;
    }
}

export interface IFileDeleteResult {
    fileUrl?: string | undefined;
    deletedDocIds?: string[] | undefined;
    blobDeleted?: boolean | undefined;
}

export class FileEmbedRequest implements IFileEmbedRequest {
    fileUrls?: string[] | undefined;

    constructor(data?: IFileEmbedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileUrls"])) {
                this.fileUrls = [] as any;
                for (let item of _data["fileUrls"])
                    this.fileUrls!.push(item);
            }
        }
    }

    static fromJS(data: any): FileEmbedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileEmbedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileUrls)) {
            data["fileUrls"] = [];
            for (let item of this.fileUrls)
                data["fileUrls"].push(item);
        }
        return data;
    }
}

export interface IFileEmbedRequest {
    fileUrls?: string[] | undefined;
}

export class FileEmbedResponseItem implements IFileEmbedResponseItem {
    fileUrl?: string | undefined;
    docId?: string | undefined;
    chunks?: number | undefined;
    replaced?: boolean | undefined;
    status?: string | undefined;
    error?: string | undefined;

    constructor(data?: IFileEmbedResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileUrl = _data["fileUrl"];
            this.docId = _data["docId"];
            this.chunks = _data["chunks"];
            this.replaced = _data["replaced"];
            this.status = _data["status"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): FileEmbedResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileEmbedResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileUrl"] = this.fileUrl;
        data["docId"] = this.docId;
        data["chunks"] = this.chunks;
        data["replaced"] = this.replaced;
        data["status"] = this.status;
        data["error"] = this.error;
        return data;
    }
}

export interface IFileEmbedResponseItem {
    fileUrl?: string | undefined;
    docId?: string | undefined;
    chunks?: number | undefined;
    replaced?: boolean | undefined;
    status?: string | undefined;
    error?: string | undefined;
}

export class FileListItem implements IFileListItem {
    fileName?: string | undefined;
    blobPath?: string | undefined;
    fileUrl?: string | undefined;
    contentType?: string | undefined;
    size?: number | undefined;
    lastModifiedUtc?: Date | undefined;
    embedded?: boolean | undefined;
    docId?: string | undefined;
    isFolder?: boolean | undefined;

    constructor(data?: IFileListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.blobPath = _data["blobPath"];
            this.fileUrl = _data["fileUrl"];
            this.contentType = _data["contentType"];
            this.size = _data["size"];
            this.lastModifiedUtc = _data["lastModifiedUtc"] ? new Date(_data["lastModifiedUtc"].toString()) : <any>undefined;
            this.embedded = _data["embedded"];
            this.docId = _data["docId"];
            this.isFolder = _data["isFolder"];
        }
    }

    static fromJS(data: any): FileListItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["blobPath"] = this.blobPath;
        data["fileUrl"] = this.fileUrl;
        data["contentType"] = this.contentType;
        data["size"] = this.size;
        data["lastModifiedUtc"] = this.lastModifiedUtc ? this.lastModifiedUtc.toISOString() : <any>undefined;
        data["embedded"] = this.embedded;
        data["docId"] = this.docId;
        data["isFolder"] = this.isFolder;
        return data;
    }
}

export interface IFileListItem {
    fileName?: string | undefined;
    blobPath?: string | undefined;
    fileUrl?: string | undefined;
    contentType?: string | undefined;
    size?: number | undefined;
    lastModifiedUtc?: Date | undefined;
    embedded?: boolean | undefined;
    docId?: string | undefined;
    isFolder?: boolean | undefined;
}

export class FileUploadResponseItem implements IFileUploadResponseItem {
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    status?: string | undefined;
    error?: string | undefined;

    constructor(data?: IFileUploadResponseItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileUrl = _data["fileUrl"];
            this.status = _data["status"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): FileUploadResponseItem {
        data = typeof data === 'object' ? data : {};
        let result = new FileUploadResponseItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileUrl"] = this.fileUrl;
        data["status"] = this.status;
        data["error"] = this.error;
        return data;
    }
}

export interface IFileUploadResponseItem {
    fileName?: string | undefined;
    fileUrl?: string | undefined;
    status?: string | undefined;
    error?: string | undefined;
}

export class FolderCreateRequest implements IFolderCreateRequest {
    folderName?: string | undefined;

    constructor(data?: IFolderCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderName = _data["folderName"];
        }
    }

    static fromJS(data: any): FolderCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FolderCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderName"] = this.folderName;
        return data;
    }
}

export interface IFolderCreateRequest {
    folderName?: string | undefined;
}

export class FolderDeleteResult implements IFolderDeleteResult {
    folderPath?: string | undefined;
    deletedFiles?: number | undefined;
    deletedDocIds?: string[] | undefined;

    constructor(data?: IFolderDeleteResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.folderPath = _data["folderPath"];
            this.deletedFiles = _data["deletedFiles"];
            if (Array.isArray(_data["deletedDocIds"])) {
                this.deletedDocIds = [] as any;
                for (let item of _data["deletedDocIds"])
                    this.deletedDocIds!.push(item);
            }
        }
    }

    static fromJS(data: any): FolderDeleteResult {
        data = typeof data === 'object' ? data : {};
        let result = new FolderDeleteResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["folderPath"] = this.folderPath;
        data["deletedFiles"] = this.deletedFiles;
        if (Array.isArray(this.deletedDocIds)) {
            data["deletedDocIds"] = [];
            for (let item of this.deletedDocIds)
                data["deletedDocIds"].push(item);
        }
        return data;
    }
}

export interface IFolderDeleteResult {
    folderPath?: string | undefined;
    deletedFiles?: number | undefined;
    deletedDocIds?: string[] | undefined;
}

export class FolderRenameRequest implements IFolderRenameRequest {
    sourceFolder?: string | undefined;
    targetFolder?: string | undefined;

    constructor(data?: IFolderRenameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceFolder = _data["sourceFolder"];
            this.targetFolder = _data["targetFolder"];
        }
    }

    static fromJS(data: any): FolderRenameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FolderRenameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceFolder"] = this.sourceFolder;
        data["targetFolder"] = this.targetFolder;
        return data;
    }
}

export interface IFolderRenameRequest {
    sourceFolder?: string | undefined;
    targetFolder?: string | undefined;
}

export class LiveShareSendRequest implements ILiveShareSendRequest {
    shareId?: string | undefined;
    payload?: any | undefined;
    senderId?: string | undefined;

    constructor(data?: ILiveShareSendRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shareId = _data["shareId"];
            this.payload = _data["payload"];
            this.senderId = _data["senderId"];
        }
    }

    static fromJS(data: any): LiveShareSendRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LiveShareSendRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shareId"] = this.shareId;
        data["payload"] = this.payload;
        data["senderId"] = this.senderId;
        return data;
    }
}

export interface ILiveShareSendRequest {
    shareId?: string | undefined;
    payload?: any | undefined;
    senderId?: string | undefined;
}

export class LiveShareStartResponse implements ILiveShareStartResponse {
    shareId?: string | undefined;
    createdAtUtc?: number | undefined;

    constructor(data?: ILiveShareStartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shareId = _data["shareId"];
            this.createdAtUtc = _data["createdAtUtc"];
        }
    }

    static fromJS(data: any): LiveShareStartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LiveShareStartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shareId"] = this.shareId;
        data["createdAtUtc"] = this.createdAtUtc;
        return data;
    }
}

export interface ILiveShareStartResponse {
    shareId?: string | undefined;
    createdAtUtc?: number | undefined;
}

export class OpenAiBudgetResponse implements IOpenAiBudgetResponse {
    periodStartUtc?: Date | undefined;
    periodEndUtc?: Date | undefined;
    currency?: string | undefined;
    spent?: number | undefined;
    budgetLimit?: number | undefined;
    remaining?: number | undefined;

    constructor(data?: IOpenAiBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodStartUtc = _data["periodStartUtc"] ? new Date(_data["periodStartUtc"].toString()) : <any>undefined;
            this.periodEndUtc = _data["periodEndUtc"] ? new Date(_data["periodEndUtc"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.spent = _data["spent"];
            this.budgetLimit = _data["budgetLimit"];
            this.remaining = _data["remaining"];
        }
    }

    static fromJS(data: any): OpenAiBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OpenAiBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodStartUtc"] = this.periodStartUtc ? this.periodStartUtc.toISOString() : <any>undefined;
        data["periodEndUtc"] = this.periodEndUtc ? this.periodEndUtc.toISOString() : <any>undefined;
        data["currency"] = this.currency;
        data["spent"] = this.spent;
        data["budgetLimit"] = this.budgetLimit;
        data["remaining"] = this.remaining;
        return data;
    }
}

export interface IOpenAiBudgetResponse {
    periodStartUtc?: Date | undefined;
    periodEndUtc?: Date | undefined;
    currency?: string | undefined;
    spent?: number | undefined;
    budgetLimit?: number | undefined;
    remaining?: number | undefined;
}

export class PdfRenderRequest implements IPdfRenderRequest {
    fileName?: string | undefined;
    markdownContent?: string | undefined;
    title?: string | undefined;

    constructor(data?: IPdfRenderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.markdownContent = _data["markdownContent"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PdfRenderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PdfRenderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["markdownContent"] = this.markdownContent;
        data["title"] = this.title;
        return data;
    }
}

export interface IPdfRenderRequest {
    fileName?: string | undefined;
    markdownContent?: string | undefined;
    title?: string | undefined;
}

export class PdfShareRequest implements IPdfShareRequest {
    recipients?: string[] | undefined;
    markdownContent?: string | undefined;
    fileName?: string | undefined;
    subject?: string | undefined;

    constructor(data?: IPdfShareRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["recipients"])) {
                this.recipients = [] as any;
                for (let item of _data["recipients"])
                    this.recipients!.push(item);
            }
            this.markdownContent = _data["markdownContent"];
            this.fileName = _data["fileName"];
            this.subject = _data["subject"];
        }
    }

    static fromJS(data: any): PdfShareRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PdfShareRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipients)) {
            data["recipients"] = [];
            for (let item of this.recipients)
                data["recipients"].push(item);
        }
        data["markdownContent"] = this.markdownContent;
        data["fileName"] = this.fileName;
        data["subject"] = this.subject;
        return data;
    }
}

export interface IPdfShareRequest {
    recipients?: string[] | undefined;
    markdownContent?: string | undefined;
    fileName?: string | undefined;
    subject?: string | undefined;
}

export class ProfileSuggestionResponse implements IProfileSuggestionResponse {
    originalProfile?: string | undefined;
    suggestedProfile?: string | undefined;
    vectorStoreSummary?: string | undefined;

    constructor(data?: IProfileSuggestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalProfile = _data["originalProfile"];
            this.suggestedProfile = _data["suggestedProfile"];
            this.vectorStoreSummary = _data["vectorStoreSummary"];
        }
    }

    static fromJS(data: any): ProfileSuggestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileSuggestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalProfile"] = this.originalProfile;
        data["suggestedProfile"] = this.suggestedProfile;
        data["vectorStoreSummary"] = this.vectorStoreSummary;
        return data;
    }
}

export interface IProfileSuggestionResponse {
    originalProfile?: string | undefined;
    suggestedProfile?: string | undefined;
    vectorStoreSummary?: string | undefined;
}

export class SignalRConnectionInfo implements ISignalRConnectionInfo {
    url?: string | undefined;
    accessToken?: string | undefined;

    constructor(data?: ISignalRConnectionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.accessToken = _data["accessToken"];
        }
    }

    static fromJS(data: any): SignalRConnectionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SignalRConnectionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["accessToken"] = this.accessToken;
        return data;
    }
}

export interface ISignalRConnectionInfo {
    url?: string | undefined;
    accessToken?: string | undefined;
}

export class ToolCallParameterViewModel implements IToolCallParameterViewModel {
    name?: string | undefined;
    value?: string | undefined;

    constructor(data?: IToolCallParameterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ToolCallParameterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ToolCallParameterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface IToolCallParameterViewModel {
    name?: string | undefined;
    value?: string | undefined;
}

export class ToolCallViewModel implements IToolCallViewModel {
    id?: string | undefined;
    functionName?: string | undefined;
    pluginName?: string | undefined;
    jsonSerialisedArguments?: string | undefined;
    uiParameters?: ToolCallParameterViewModel[] | undefined;
    uiFunctionCallSummary?: string | undefined;
    uiFunctionResultSummary?: string | undefined;
    callTimeStamp?: number | undefined;
    validationSignature?: string | undefined;
    callNeedsToBeValidated?: boolean | undefined;
    approvalStatus?: string | undefined;

    constructor(data?: IToolCallViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.functionName = _data["functionName"];
            this.pluginName = _data["pluginName"];
            this.jsonSerialisedArguments = _data["jsonSerialisedArguments"];
            if (Array.isArray(_data["uiParameters"])) {
                this.uiParameters = [] as any;
                for (let item of _data["uiParameters"])
                    this.uiParameters!.push(ToolCallParameterViewModel.fromJS(item));
            }
            this.uiFunctionCallSummary = _data["uiFunctionCallSummary"];
            this.uiFunctionResultSummary = _data["uiFunctionResultSummary"];
            this.callTimeStamp = _data["callTimeStamp"];
            this.validationSignature = _data["validationSignature"];
            this.callNeedsToBeValidated = _data["callNeedsToBeValidated"];
            this.approvalStatus = _data["approvalStatus"];
        }
    }

    static fromJS(data: any): ToolCallViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ToolCallViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["functionName"] = this.functionName;
        data["pluginName"] = this.pluginName;
        data["jsonSerialisedArguments"] = this.jsonSerialisedArguments;
        if (Array.isArray(this.uiParameters)) {
            data["uiParameters"] = [];
            for (let item of this.uiParameters)
                data["uiParameters"].push(item ? item.toJSON() : <any>undefined);
        }
        data["uiFunctionCallSummary"] = this.uiFunctionCallSummary;
        data["uiFunctionResultSummary"] = this.uiFunctionResultSummary;
        data["callTimeStamp"] = this.callTimeStamp;
        data["validationSignature"] = this.validationSignature;
        data["callNeedsToBeValidated"] = this.callNeedsToBeValidated;
        data["approvalStatus"] = this.approvalStatus;
        return data;
    }
}

export interface IToolCallViewModel {
    id?: string | undefined;
    functionName?: string | undefined;
    pluginName?: string | undefined;
    jsonSerialisedArguments?: string | undefined;
    uiParameters?: ToolCallParameterViewModel[] | undefined;
    uiFunctionCallSummary?: string | undefined;
    uiFunctionResultSummary?: string | undefined;
    callTimeStamp?: number | undefined;
    validationSignature?: string | undefined;
    callNeedsToBeValidated?: boolean | undefined;
    approvalStatus?: string | undefined;
}

export class ToolResultViewModel implements IToolResultViewModel {
    toolCallId?: string | undefined;
    functionName?: string | undefined;
    pluginName?: string | undefined;
    content?: string | undefined;

    constructor(data?: IToolResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.toolCallId = _data["toolCallId"];
            this.functionName = _data["functionName"];
            this.pluginName = _data["pluginName"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): ToolResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ToolResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["toolCallId"] = this.toolCallId;
        data["functionName"] = this.functionName;
        data["pluginName"] = this.pluginName;
        data["content"] = this.content;
        return data;
    }
}

export interface IToolResultViewModel {
    toolCallId?: string | undefined;
    functionName?: string | undefined;
    pluginName?: string | undefined;
    content?: string | undefined;
}

export class UploadedFileModel implements IUploadedFileModel {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64Content?: string | undefined;

    constructor(data?: IUploadedFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.contentType = _data["contentType"];
            this.base64Content = _data["base64Content"];
        }
    }

    static fromJS(data: any): UploadedFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["contentType"] = this.contentType;
        data["base64Content"] = this.base64Content;
        return data;
    }
}

export interface IUploadedFileModel {
    fileName?: string | undefined;
    contentType?: string | undefined;
    base64Content?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}
